import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CsvService } from 'src/app/services/core/csv-service/csv.service';
import { StatisticsService } from 'src/app/services/core/statistics/statistics.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';

@UntilDestroy()

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
  kpiData:any;
  todayDate: any;
  dateRange:any = [];
  user:any;
  trips:any=[];
  source:any = "original";
  paymentStatus: any = '';
  paymentType: any = '';

  
  constructor(
    private statisticsService: StatisticsService,
    private sharedDataService:SharedDataService,
    private csvService:CsvService
  ){}

  ngOnInit(){
    this.getUser();
    this.todayDate = [
          moment().startOf('day').toISOString(),
          moment().endOf('day').toISOString()
        ];
    
    this.getKpi();
  }
  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.user = data;

      }

    })
  }
getKpi() {
  let queryParam:any = {
    time: [this.todayDate[0], this.todayDate[1]],
    type: 'fundingsource',
    source: this.source,
    fundingsource:this.user.fundingsource.id
  }
  if (this.source === 'fundingsource' && this.paymentStatus) {
    queryParam.payment = this.paymentStatus;
  }

  if (this.source === 'fundingsource' && this.paymentType) {
    queryParam.paymentType = this.paymentType;
  }

  this.statisticsService.get(queryParam)
    .pipe(untilDestroyed(this))
    .subscribe((result: any) => {
      if (result) {
        this.kpiData =result;
        if(result?.data?.length){
          this.trips=result.data || []
        }
      }
    });
}


  filterBySelection() {
    this.getKpi();
  }
  
  generateKpiData() {
    this.csvService.generatePrivateFSPayReport(
          this.kpiData,
          this.todayDate,
          this.source,
        );
  }

    changeSource(tab:string){
    this.source = tab
    if (tab !== 'fundingsource') {
      this.paymentStatus = '';
      this.paymentType = '';
    }
    this.kpiData = [];
    this.getKpi();
  }

  onPaymentStatusChange() {
    this.kpiData = [];
    this.getKpi();
  }

  onPaymentTypeChange() {
    this.kpiData = [];
    this.getKpi();
  }


 

  onDateChange(event: any) {
    this.todayDate = [
      event[0].toISOString(),
      moment(event[1]).endOf("day").toISOString(),
    ];
    this.kpiData = null;
    this.getKpi();
  }

}
